import { styled, Typography } from '@mui/material'
import { RoomTypes } from '@weblite/ts-action/room'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { useHistoryCustomBack } from 'weblite-router'
import { BackButton } from '$common/buttons'
import { BottomDrawer } from '$common/bottom-drawer'
import { showChatListToolboxModal } from '$comp/modals/chat-list-toolbox/index'
import { OtherWapps } from '$comp/chat-list-tool-box/components/other-wapps/other-wapps'
import { t } from '$i18n'

export function ChatListToolboxOtherWappsModal({
  isOpen,
  roomId,
  roomType,
}: {
  isOpen?: boolean
  roomId: string
  roomType?: RoomTypes
}) {
  const handleBack = async () => {
    await closeCurrentModal()
    showChatListToolboxModal()
  }

  useHistoryCustomBack(() => {
    handleBack()
  }, [])

  return (
    <BottomDrawer onClose={closeCurrentModal} isOpen={Boolean(isOpen)}>
      <Header>
        <BackButton onClick={handleBack} color="neutral700" />
        <Typography color="neutral700" variant="subtitle1">
          {t('chatListToolbox.otherWapps')}
        </Typography>
      </Header>
      <OtherWapps roomType={roomType} />
    </BottomDrawer>
  )
}

const Header = styled('div')`
  display: flex;
  gap: 5px;
  align-items: center;
  height: 44px;
  padding-right: 7px;
`
